module.exports = __webpack_public_path__ + "static/media/History.45289900.svg";